/** Fixed verification methods from ΠΑΡ.2-ΓΔ.13 (read-only display). */
export const VERIFICATION_METHOD_ITEMS = [
  {
    field: 'methodReviewFiles',
    label: 'Review of related files and documents',
  },
  {
    field: 'methodVerifyRevisedProcedures',
    label: 'Verification of revised procedures implementation (where applicable)',
  },
  {
    field: 'methodEffectivenessControlsDocumented',
    label: 'Confirmation that effectiveness controls are documented',
  },
  {
    field: 'methodDueDateDefined',
    label: 'Due date defined for the effectiveness check and CAPA closure',
  },
  {
    field: 'methodStaffInformed',
    label: 'Involved staff informed of the new requirements',
  },
  {
    field: 'methodQmsReview',
    label: 'Review of records held in the Quality Management System (QMS)',
  },
];

/** Fixed evidence items from ΠΑΡ.2-ΓΔ.13 (read-only display). */
export const EVIDENCE_REVIEWED_ITEMS = [
  {
    field: 'evidenceRevisedProcedures',
    label: 'Revised procedures (where applicable)',
  },
  {
    field: 'evidenceEn01Gd13Form',
    label: 'Completed form EN.01-ΓΔ.13',
  },
  {
    field: 'evidenceTrainingRecords',
    label: 'Staff information / training records',
  },
  {
    field: 'evidenceCapaInQms',
    label: 'CAPA records in QMS',
  },
  {
    field: 'evidenceInternalAuditOrMonitoring',
    label: 'Internal audit / monitoring results (where applicable)',
  },
];

export const EFFECTIVENESS_RESULT_LABELS = {
  EFFECTIVE: 'Effective',
  PARTIALLY_EFFECTIVE: 'Partially effective',
  NOT_EFFECTIVE: 'Not effective',
};

export const DECISION_LABELS = {
  CLOSE_CAPA: 'Close CAPA',
  KEEP_OPEN: 'Keep CAPA open',
};
